import React from 'react';
import { useNavigate } from '@reach/router';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Button, ButtonGroup, Container, Flex, Text } from '@chakra-ui/react';
import { Login20 } from '@carbon/icons-react';
import { camelCase } from 'change-case';
import Topbar from '#coreComponents/Topbar';
import TheLogo from '#coreComponents/logos/TheLogo';
import { useEnvironment } from '#core/Environment';
// JME
// import { useAuthHook } from '#utils/useAuthHook';
// JME1
import { useAuth } from '#core/Auth';

const HomeTopbar: React.FC<{}> = () => {
  const { baseUrl } = useEnvironment();
  const {
    actions: { logIn },
  } = useAuth(); // JME2
  const flags = useFlags();

  const navigate = useNavigate();

  return (
    <Topbar justifyContent="center" darkVariant={true}>
      <Container
        maxW="container.xl"
        display="flex"
        flexGrow={1}
        alignItems="center"
      >
        <Flex
          alignItems="center"
          onClick={() => navigate(baseUrl)}
          cursor="pointer"
        >
          <TheLogo
            maxHeight={10}
            w={100}
            h={10}
            mr={4}
            display={['none', 'block']}
          />
          <Text
            color="white"
            fontSize={['3xl', '4xl', '5xl']}
            fontFamily="'Baskerville', serif"
          >
            Data
            <Text
              as="span"
              color="yellow.400"
              display="inline"
              fontSize={['3xl', '4xl', '5xl']}
              fontFamily="'Baskerville', serif"
            >
              Points
            </Text>
          </Text>
        </Flex>
        <Flex flexGrow={1} justifyContent="center">
          <ButtonGroup
            variant="link"
            color="white"
            spacing={4}
            display={['none', 'none', 'block']}
          >
            <Button
              fontSize="l"
              color="white"
              onClick={() =>
                navigate(baseUrl, { state: { scrollTo: 'product' } })
              }
            >
              Product
            </Button>
            <Button
              fontSize="l"
              color="white"
              onClick={() =>
                navigate(baseUrl, { state: { scrollTo: 'customers' } })
              }
            >
              Customers
            </Button>
            <Button
              fontSize="l"
              color="white"
              onClick={() =>
                navigate(baseUrl, { state: { scrollTo: 'otherServices' } })
              }
            >
              Other Services
            </Button>
            <Button
              fontSize="l"
              color="white"
              onClick={() => navigate(`${baseUrl}sdg-quiz`)}
            >
              SDG Quiz
            </Button>
          </ButtonGroup>
        </Flex>
        <ButtonGroup colorScheme="yellow">
          <Button
            as="a"
            href="https://www.timeshighereducation.com/our-solutions/enquire-now"
            display={['none', 'none', 'none', 'flex']}
          >
            Speak to an expert
          </Button>
          <Button
            id="login-button"
            leftIcon={<Login20 />}
            onClick={() =>
              flags[camelCase('auth0Enabled')]
                ? logIn()
                : logIn({ redirectUri: window.location.href })
            }
          >
            Log In
          </Button>
        </ButtonGroup>
      </Container>
    </Topbar>
  );
};

export default HomeTopbar;
